import { useMutation } from "react-query";
import http from "infra/http";
import { PrevisaoOrcamentariaLancamento } from "../typings";

function useAtualizarLancamento(id: string) {
  return useMutation(
    (data: PrevisaoOrcamentariaLancamento) => {
      return http.put(`/v1/previsao-orcamentaria/${id}/lancamento`, data);
    },
    { retry: false }
  );
}

export default useAtualizarLancamento;
